export default class AdminsByCategoryBarService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    const pData = this.$http.get('/api/report/data_a_c_admin', {
      params: {
        chartType: 'column',
        ...params
      }
    });

    const pDrilldown = this.$http.get('/api/report/data_a_y_c_admin', {
      params: {
        chartType: 'pie',
        ...params
      }
    });

    return Promise.all([pData, pDrilldown])
    .then(([pDataResult, pDrilldownResult]) => {
      const series = pDataResult.data;
      const drilldown = { series: pDrilldownResult.data };

      return { series, drilldown };
    });
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-bar/admins-by-category-bar.service.js